$(document).ready(function() {
    $('select').niceSelect();
});
$(document).ready(function() {
    if($('#blog-filter-lst')){
        $('#blog-filter-lst').change(function(){
            link = $('#blog-filter-lst option:selected').val();
            linkfiltered = link.replace(/\s+/g, '-').toLowerCase();
            window.location.href = linkfiltered;
        });
    }
});
$(document).ready(function() {
    if($('.product-template .scroller-holder').length){
       $(window).scroll(function(){
            if($(window).scrollTop() < 50){
                $('.product-template .scroller-holder').fadeIn();
            }
            else{
                $('.product-template .scroller-holder').fadeOut();
            }
       });
    }
});
$(document).ready(function() {

});

$(window).on('load', function(){
  
      if($('.slideshow').length){
        var swiperSlideshow = new Swiper(".slideshow", {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
              },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

    }
    if($('.featured-slider').length){
        var swiperFeaturedSlider = new Swiper(".swiper", {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
              },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

    }
    if($('#store_map').length){
        function initMap() {

            var stores;
            var storesHeader;
            var myMapCenter = {lat: 45.5016889, lng: -73.567256};

            // Crée la google map
            var map = new google.maps.Map(document.getElementById('store_map'), {
                center: myMapCenter,
                zoom: 9,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ]
            });

            var geocoder = new google.maps.Geocoder();
            var infoWindow = new google.maps.InfoWindow();

            $('.store_search').on('click', searchStores);

            // Affiche les magasins près du code postal entré
            function searchStores(){
                var zipCode = $('#zip_code').val();
                geocoder.geocode({
                        'address': zipCode
                }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                                map.setCenter(results[0].geometry.location);
                        } else {
                                alert("Aucun résultat.");
                        }
                });
            }

            // Ajoute les markers
            function markStore(storeInfo){

                var lat = APIField("latitude", storeInfo);
                var lng = APIField("longitude", storeInfo);
                var icon = {
                    url: 'https://cdn.shopify.com/s/files/1/0561/2879/8908/files/pin_localisation.svg?v=1619808315', // url
                    scaledSize: new google.maps.Size(39, 35), // scaled size
                    origin: new google.maps.Point(0,0), // origin
                    anchor: new google.maps.Point(0, 0) // anchor
                };
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: map,
                    icon: icon
                });

                function showStoreInfo() {

                    var storeInfo = this.location;
                    var title = "<span class='gm-info-title'><strong>" + APIField("succursale", storeInfo) + "</strong></span>";
                    var directions = "<a class='directions_link' href='https://www.google.com/maps/search/?api=1&query=" + APIField("latitude", storeInfo) + "," + APIField("longitude", storeInfo) + "' target='_blank'>Obtenir des directions</a>";

                    infoWindow.setContent([title, '<p class="gm-info-desc">'+APIField("adresse", storeInfo)+'</p>', directions, ""].join(""));
                    infoWindow.open(map, this.marker);
                }

                marker.addListener(
                    "click", showStoreInfo.bind({ location: storeInfo, marker: marker })
                );
            }

            // Fetch les stores depuis un fichier XLS
            function fetchStores(){
                $.get(
                    "https://sheets.googleapis.com/v4/spreadsheets/"+ RTID +"/values/Feuille 1?key=AIzaSyBvHBa0aw-zMhA6lbM6in5zRPZn2B-atac"
                ).then(function(res) {
                    stores = res.values;
                    storesHeader = stores[0].map(name => name.toLowerCase());
                    stores.splice(0, 1);
                    setStores();
                });
            }
            fetchStores();

            // Attend d'avoir les stores avant de créer les markers
            function setStores(){
                if (typeof stores === "undefined" || stores === null) {
                    setTimeout(function() {
                        setStores();
                    }, 500);
                    return;
                }

                stores.forEach(function(store){
                    markStore(store);
                });
            }

            // Obtient les fields de spreadsheet
            function APIField(name, obj) {
                var index = storesHeader.indexOf(name);
                if(obj[index]){
                    return obj[index];
                }
                else{
                    return "";
                }
            }
        }
        initMap();
    }
});

$(document).ready(function(){
    if($('.section-parallax').length){
        $('.section-parallax').each(function(){
            var blocWidth = $(this).find('.parallax-wrapper').width();
            $(this).find('.parallax').css('width', blocWidth - 15);

            $(window).on('resize', () => {
                var blocWidth = $(this).find('.parallax-wrapper').width();
                $(this).find('.parallax').css('width', blocWidth - 15);
            });
        });
    }
});


$(document).ready(function(){
    if($('.section-popup').length){
        setTimeout(function(){
            $('.section-popup').css('transform', 'translateX(0)');
        }, 2000);

        $('.section-popup').find('.close-pop').click(function(){
            $('.section-popup').css('transform', 'translateX(100%)');
        });
    }
});
